<template>
  <div id="app">
    <div class="d-md-flex  ">
      <a href="https://ardi.ge/"><img src="../src/assets/img/cross.svg" class="cross d-md-block d-none"></a>
      <a href="https://ardi.ge/"><img src="../src/assets/img/cross-wt.svg" class="cross d-block d-md-none"></a>
      <div class="header d-block">
        <a href="https://ardi.ge/"><img src="../src/assets/img/logo-wt.svg" class="md-logo" width="200" alt="Ardi"></a>
        <!-- <div class="gradient"></div>
         <div class="circle circle_1"> </div>
         <div class="circle circle_2"> </div>
         <div class="circle circle_3"> </div>-->
      </div>
      <div class="content mb-5">
        <div class="">
          <img src="../src/assets/img/logo.svg" width="115" class="d-md-block d-none"/>
          <div class="text-center NotoSerifGeorgian-Bold title pt-4 mb-4">
            ვიზიტის ჯავშანი
          </div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style>
@import '~bootstrap-vue/dist/bootstrap-vue.min.css';
@import "~bootstrap/dist/css/bootstrap.min.css";
@import "../src/assets/css/style.css";

/*.header{
  background:#106F5D;
  !*background: linear-gradient(135deg, #399176 0%,  #0A2B22 100%);*!
  height: 100vh;
  width: 50%;
}*/
.header {
  height: 100vh;
  width: 50vw;
  position: relative;
  background: url("../src/assets/img/md-back.svg") center center;
  background-size: cover;
}

@media only screen and (max-width: 600px) {
  .header {
    height: 10vh;
    width: 100vw;
    position: relative;
    background: url("../src/assets/img/sm-back.svg") center center;
    background-size: cover;
  }
  .md-logo{
    width: 115px;
  }
  .cross {
    z-index: 2;
    position: absolute;
    top: 4% !important;
    right: 3%;
  }

  /*.content{*/
  /*  height: auto;*/
  /*  overflow-y: auto;*/
  /*  padding: 3rem 7rem  0 7rem;*/
  /*}*/
}

.cross {
  position: absolute;
  top: 8%;
  right: 3%;
}

.content {
  width: 50vw;
  height: 91vh;
  overflow-y: auto;
  padding: 3rem 7rem 0 7rem;
}

.gradient {
  background: linear-gradient(135deg, #39917647 0%, #0a2b224d 100%);
  position: absolute;
  height: 100vh;
  width: 50%;
}

.circle {
  width: 440px;
  height: 440px;
  border: 60px solid;
  border-radius: 50%;
}

.circle_1 {
  position: absolute;
  transform: translate(-232px, -101px);
  top: 0;
  /*left: -101px;*/
  border-color: #4EC689;
}

.circle_2 {
  position: absolute;
  transform: translate(298px, -365px);
  top: 0;
  border-color: #7FD9AB;
}

.circle_3 {
  position: absolute;
  transform: translate(-107px, 521px);
  top: 0;
  border-color: #A2D1D1;
}

.title {
  font-size: 24px;
}

.home {
  /*padding: 0 4rem !important;*/
}

.md-logo {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
}


/*#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>
